import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Moment from "react-moment";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { toast } from "react-toastify";
import "../styles/UserCard.scss"

function getPlayerStateKey(user) {

    if (user.isConnected && user.isSpectating) {
        return "spectating";
    }

    if (user.isConnected && user.segmenterState === "recording" || user.segmenterState === "segmenting" || user.segmenterState === "replaying") {
        return `${user.segmenterState}`;
    }

    if (user.isConnected && user.ghostPlayState) {
        return "ghostplay";
    }

    if (user.isConnected && !user.isSpectating) {
        return "playing";
    }

    return "idling";
}

function playerStateKeyToLabel(key) {
    return {
        spectating: "spectating",
        recording: "recording a segment",
        segmenting: "segmenting a segment",
        replaying: "replaying a segment",
        ghostplay: "simulating in GhostPlay",
        playing: "playing",
        idling: "idling in menu"
    }[key];
}

const eloThresholds = [
    0,    // lvl 0
    50,   // lvl 1
    150,  // lvl 2
    300,  // lvl 3
    500,  // lvl 4
    750,  // lvl 5
    1000, // lvl 6
    1300, // lvl 7
    1650, // lvl 8
    2000, // lvl 9
    2500, // lvl 10
    3250, // pro (lvl 11)
    4000  // goat (lvl 12)
];

function levelFromElo(elo) {
    let lvl = 0;
    for (let i = 0; i < eloThresholds.length; i++) {
        if (elo >= eloThresholds[i]) lvl = i;
        else break;
    }
    return lvl;
}

function getUserActivityLabel(user) {

    const key = getPlayerStateKey(user);
    const label = playerStateKeyToLabel(key);
    
    return (
        <span className={key}>
            Currently {label} {key === "spectating" ? <span className="spectating-name">{user.spectatingClientName}</span> : ""}
        </span>
    );
}

function isDormant(user) {
    const timeout = (1000 * 60 * 60 * 24 * 7);
    return (new Date(user.lastLogin).getTime() + timeout) <= Date.now();
}

function UserCard({user, fetchConfigHandler}) {

    const copyHandler = () => {
        toast(`Copied ${user.name}'s guid!`);
    }

    return (
        <div className={`user ${isDormant(user) ? "dormant" : ""} ${user.isOnline ? "glow" : ""} ${user.tasState ? "blue" : "green"}`}>
            <div className="header">
                <div className="username">

                    {/* <FontAwesomeIcon className="icon user" icon={faIdCardClip}/> */}
                    <img className="anvil-A" src="/anvillogo.png" />
                    <span className={`lvl-${levelFromElo(user.elo)} rank`}/>
                    {/* {user.isAdmin ? (
                        <FontAwesomeIcon className="icon admin" icon={faCrown} />
                    ): (
                        <></>
                    )} */}

                    <div className="name" onClick={() => fetchConfigHandler(user)}>{user.name}</div>
                    <img className="country" src={`/flags/${user.countryCode}.png`} />
                
                </div>
                {
                    user.isOnline ? (
                        <div className="online"></div>

                    ) : (
                        <div className="offline"></div>

                    )
                }
            </div>
            <div className="body">
                <div className="account-type">
                    {
                        user.isAdmin ? (<span className="admin">System Admin</span>) : (<span className="regular-user">User</span>)
                    }
                </div>
                <div>
                    <b>Joined:</b> 
                    <Moment fromNow className="time-label">{user.joinedAt}</Moment>
                </div>
                <div>
                    <b>Last Login:</b> 
                    <Moment fromNow className="time-label">{user.lastLogin}</Moment>
                </div>
                <div className="playtime">
                    <b>Playtime:</b> 
                    <span className="time-label">{(user.playTime / 3600).toFixed(1)} hrs on record</span>
                </div>
                <div className="elo">
                    <b>Elo:</b> 
                    <span className={`elo-text elo-tier-${levelFromElo(user.elo)}`}>{user.elo}</span>
                </div>
                {/* <div className="origin">
                    <b>Country:</b> 
                    <img className="country" src={`/flags/${user.countryCode}.png`} />
                </div> */}

                {
                    user.isOnline  ? (
                        <>
                            <div className="playerstate">
                                {getUserActivityLabel(user)}
                            </div>    
                            <div className="servername">
                                <b>Server: </b>
                                <span>{user.servername}</span>
                            </div>
                            <div className="serverip">
                                <b>IP: </b>
                                <span>{user.serveraddress}</span>
                            </div>
                            <div className="mapname">
                                <b>Map: </b>
                                <span>{user.mapname}</span>
                            </div>
                            <div className="cheatstate">
                                <b>State: </b>
                                <span className={user.tasState ? "tas" : "legit"}>{user.tasState ? "TAS" : "Legit"}</span>
                            </div>
                        </>

                    ) : (
                        <>
                        <div className="playerstate">
                            <span>Currently offline</span>
                        </div>    
                        <div className="servername">
                            <b>Server: </b>
                            <span>n/a</span>
                        </div>
                        <div className="serverip">
                            <b>IP: </b>
                            <span>n/a</span>
                        </div>
                        <div className="mapname">
                            <b>Map: </b>
                            <span>n/a</span>
                            </div>
                        <div className="cheatstate">
                            <b>State: </b>
                            <span>n/a</span>
                        </div>
                    </>
                    )
                }

                <div class="guid">
                    <b>GUID:</b>

                    {
                        user.guid ? (
                            <>
                            <span class="guid-value">{user.guid}</span>
                            <CopyToClipboard text={user.guid} onCopy={copyHandler}>
                                <span className="icon copy">
                                    <FontAwesomeIcon title="Copy to clipboard" icon={faCopy} />
                                </span>
                            </CopyToClipboard>
                            </>
                        ) : (
                            "Pending..."
                        )
                    }

                    
                </div>
            </div>
            
        </div>
    )
}

export default UserCard;
